import React from 'react';

const WhyChooseUs = () => {
  const reasons = [
    "Expert surgeon - Dr. Deepika Sinha with international qualifications",
    "State-of-the-art technology and safe facility in Bhopal",
    "Authenticity and reliability with proven track record",
    "360° holistic aesthetic care",
    "Highly qualified doctor with cutting-edge technology and world-class quality care",
    "Strict adherence to safety protocols and hygiene standards"
  ];

  return (
    <section className="why-choose-us">
      <div className="container">
        <div className="why-choose-content">
          <div className="why-choose-text">
            <h2 className="section-title">Why do our patients choose us ? Because WE CARE</h2>
            <div className="reasons-list">
              {reasons.map((reason, index) => (
                <div key={index} className="reason-item">
                  <span className="reason-number">{index + 1}.</span>
                  <p className="reason-text">{reason}</p>
                </div>
              ))}
            </div>
            <div className="why-choose-actions">
              {/* <a href="#" className="read-more-link">Read More</a>
              <a href="tel:+91-9654495307" className="contact-btn">
                <i className="fas fa-phone"></i>
                +91-9654495307
              </a> */}
            </div>
          </div>
          <div className="why-choose-images">
            {/* <OptImage src="/images/choose-us/choose-us-img.jpg" alt="Why Choose Us" className="choose-us-img" />
            <OptImage src="/images/choose-us/best-qualified-doctor.jpg" alt="Best Qualified Doctor" className="doctor-img" /> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;